// Тарифы для страницы «Тарифы» и оферты.
// Цена и срок Pro — условия оферты: поменялись — новая редакция (`OFFER_REVISION`).
// Дневной лимит бесплатной версии повторяет `runtime_config.free_analyses_per_day` бэкенда
// (по умолчанию 5): поменял значение по умолчанию там — поправь здесь.
export const FREE_ANALYSES_PER_DAY = 5;

export const PRO_PLAN = {
  priceRub: 299,
  periodDays: 30,
} as const;
